import React, {useState} from 'react';
import 'react-spring-bottom-sheet/dist/style.css'
import styled from 'styled-components';
import {Button, Checkbox, FormControl, FormLabel, Input, useToast} from "@chakra-ui/react";
import {ChevronDown, ChevronUp} from "lucide-react";
import {Header, Title} from "../sheet";
import useFeedback from "../../../utils/use_feedback";
import {useAddModerator} from "../../../api/moderation";
import {themecolors} from "../../../utils/themecolors";

const Toggle = styled.div``;

const AddModeratorSheet = styled(({className, community, onClose}) => {

        const [showPermissions, setShowPermissions] = useState(false);
        const [moderator, setModerator] = useState({
            community,
            author: '',
            all_permissions: false,
            manage_rules: false,
            manage_automoderator: false,
            manage_settings: false,
            manage_stylesheet: false,
            manage_sidebar: false,
        });
        const set = (name) => (value) => setModerator((moderator) => ({...moderator, [name]: value}));
        const {feedbackCh} = useFeedback();
        const toast = useToast();
        const addModerator = useAddModerator(feedbackCh);
        const [saving, setSaving] = useState(false);
        const handleSave = async () => {
            setSaving(true);
            await addModerator(moderator);
            toast({
                title: `Successfully added!`,
                status: 'success',
                isClosable: true,
            });
            setSaving(false);
            onClose();
        };

        return (
            <div className={className}>

                <Header>
                    <Title>Add Moderator</Title>
                </Header>

                <FormControl>
                    <FormLabel>Username</FormLabel>
                    <Input placeholder="Cats" value={moderator.author} onChange={(e) => set('author')(e.currentTarget.value)}/>
                </FormControl>

                <Toggle onClick={() => setShowPermissions(!showPermissions)}>
                    {showPermissions ? 'Hide' : 'Show'} Permissions Settings
                    {showPermissions ?
                        <ChevronUp size={20} />
                        :
                        <ChevronDown size={20} />
                    }
                </Toggle>
                {showPermissions &&
                    <>
                        <FormControl pb={1} pt={4}>
                            <Checkbox size='md' value={moderator.all_permissions}
                                      onChange={(e) => set('all_permissions')(e.target.checked)}>All Permissions</Checkbox>
                        </FormControl>
                        <FormControl pb={1}>
                            <Checkbox size='md' value={moderator.manage_rules}
                                      onChange={(e) => set('manage_rules')(e.target.checked)}>Manage Rules</Checkbox>
                        </FormControl>
                        <FormControl pb={1}>
                            <Checkbox size='md' value={moderator.manage_sidebar}
                                      onChange={(e) => set('manage_sidebar')(e.target.checked)}>Manage Sidebar</Checkbox>
                        </FormControl>
                        <FormControl pb={1}>
                            <Checkbox size='md' value={moderator.manage_automoderator}
                                      onChange={(e) => set('manage_automoderator')(e.target.checked)}>Manage Filter</Checkbox>
                        </FormControl>
                        <FormControl pb={1}>
                            <Checkbox size='md' value={moderator.manage_settings}
                                      onChange={(e) => set('manage_settings')(e.target.checked)}>Manage Settings</Checkbox>
                        </FormControl>
                        <FormControl>
                            <Checkbox size='md' value={moderator.manage_stylesheet}
                                      onChange={(e) => set('manage_stylesheet')(e.target.checked)}>Manage Stylesheet</Checkbox>
                        </FormControl>
                    </>
                }

                <Button variant={"blue"} style={{width: '100%'}} mt={8} onClick={handleSave}>Save</Button>

            </div>
        );
    }
)`
  ${Toggle} {
    font-size: 15px;
    display: flex;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_medium_impact_text};
    cursor: pointer;
    padding-top: 12px;
  }

  ${Toggle} svg {
    margin-left: auto;
  }
`;

export default AddModeratorSheet;
